import { 
    GET_GROUP,
    GET_GROUPS,
    GET_MODAL_GROUPS,
    SET_SELECTED_GROUP,
    SET_GROUPS,
    SET_LAST_GROUPS,
    GROUP_ERROR,
    CLEAR_GROUPS,
    CLEAR_GROUP,
    GROUPS_LOADING,
    UPDATE_GROUP,
    GROUP_UPDATE_LOADED,
    GROUP_UPDATE_LOADING,
    SET_SHOW_BOTTOM_SPINNER_4_GROUPS,
    SET_LAST_GROUP_DOC,
    SET_NO_MORE_GROUPS
} from "../actions/types";

const initialState = {
    group: null,
    selected_group: null,
    groups: [],
    modal_groups: [],
    no_more_groups: false,
    show_bottom_spinner: false,
    last_page_doc: 0,
    loading: true,
    modal_loading: true,
    group_update_loading: false,
    error: {}
}

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case GROUPS_LOADING:

            // Set the loading state to true
            return {
                ...state,
                loading: true
            };
        case GROUP_UPDATE_LOADING:

            return {
                ...state,
                group_update_loading: true,
            }
        case GROUP_UPDATE_LOADED:

            return {
                ...state,
                group_update_loading: false,
            }
        case GET_GROUP:

            // Set the group state to the payload value and set loading to false
            return {
                ...state,
                group: payload,
                loading: false
            }
        case GET_GROUPS:

            // Set the groups state to the payload value,
            // mark all groups as read, and set loading to false
            return {
                ...state,
                groups: payload,
                loading: false
            }
        case GET_MODAL_GROUPS:

            // Set the groups state to the payload value,
            // mark all groups as read, and set loading to false
            return {
                ...state,
                modal_groups: payload,
                modal_loading: false
            }
        case SET_SELECTED_GROUP:

            // Set the selected_group state to the payload value,
            return {
                ...state,
                selected_group: payload,
            }
        case SET_GROUPS: {

            // Merge the existing groups with the payload groups,
            // and update the groups state accordingly
            const groups = action.payload;
            let tempGroups = groups; 
            
            if(state.groups.length > 0) {
                tempGroups= [...state.groups, ...tempGroups ];
            }

            return {
                ...state,
                groups: tempGroups,
                loading: false
            };
        }
        case SET_LAST_GROUPS: {

            // Merge the existing groups with the payload groups, and update the groups state
            const groups = action.payload;
            let tempGroups = groups; 
            
            if(state.groups.length > 0) {
                tempGroups= [...state.groups, ...tempGroups ];
            }

            return {
                ...state,
                groups: tempGroups,
                no_more_groups: true,
                loading: false
            };
        }
        case UPDATE_GROUP:

            // Update state with given group data
            return {
                ...state,
                group: payload
            }
        case GROUP_ERROR:

            // Set the error state to the payload value and set loading to false
            return {
                ...state,
                error: payload,
                loading: false,
            };
        case SET_SHOW_BOTTOM_SPINNER_4_GROUPS:
            return {
                ...state,
                show_bottom_spinner: payload
            };
        case SET_LAST_GROUP_DOC:

            return {
                ...state,
                last_page_doc: payload
            };
        case SET_NO_MORE_GROUPS:
            return {
                ...state,
                no_more_groups: payload
            };
        case CLEAR_GROUP:

            // Clear the notifications state and set loading to false
            return {
                ...state,
                group: null,
                loading: false,
            }
        case CLEAR_GROUPS:

            // Clear the notifications state and set loading to false
            return {
                ...state,
                groups: [],
                loading: false,
            }
        default:
            return state;
    }
}